import { Box } from '@primer/react';
import LiveCheckInHocSinhList from './LiveCheckInHocSinhList';
import { useHubCheckinContext } from '../../contexts/HubCheckinProvider';
import Toolbar from '../live-checkin/Toolbar';
import HighlightCheckInHocSinh from './HighlightCheckInHocSinh';
import { useLiveCheckinDataContext } from '../live-checkin/useLiveCheckInDataContext';

const LiveCheckinPublicContent = () => {
    const { _isConnected } = useHubCheckinContext();
    const { filteredData } = useLiveCheckinDataContext();

    return (
        <Box sx={{
            p: 3,
            display: "flex",
            gap: 1,
            flexDirection: "column",
            height: window.innerHeight,
            backgroundImage: _isConnected
                ? "linear-gradient(to top, #f3e7e9 0%, #e3eeff 99%, #e3eeff 100%);"
                : "linear-gradient(-225deg, #B6CEE8 0%, #F578DC 100%);"
        }}>
            <Box sx={{ backgroundColor: "transparent", borderRadius: 3, p: 2 }}>
                <Toolbar />
            </Box>
            <Box sx={{
                flex: 1,
                display: "grid",
                gridTemplateColumns: "1fr 2fr",
                gap: 3
            }}>
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3
                }}>
                    <HighlightCheckInHocSinh data={filteredData[0] != null && filteredData[0]} isInvalid={true} />
                </Box>
                <Box sx={{
                    backgroundColor: "#ffff",
                    backdropFilter: "blur(1rem)",
                    p: 3,
                    borderRadius: 3,
                    border: "1px solid",
                    borderColor: "border.default"
                }}>
                    <LiveCheckInHocSinhList />
                </Box>

            </Box>
        </Box>
    );
};

export default LiveCheckinPublicContent;